import { render, staticRenderFns } from "./PageComponent.vue?vue&type=template&id=d31cae16&scoped=true&"
import script from "./PageComponent.vue?vue&type=script&lang=js&"
export * from "./PageComponent.vue?vue&type=script&lang=js&"
import style0 from "./PageComponent.vue?vue&type=style&index=0&id=d31cae16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31cae16",
  null
  
)

export default component.exports